export function optionGroupsFactory({ key, items, segments, traveller, gdsServiceType }) {
    const isAllSegments = key === 'allSegments';
    const segment = !isAllSegments ? segments.find(segment => segment.id === key) : null;
    switch (gdsServiceType) {
        case 'Seat':
        case 'Meal':
        case 'Upgrade':
        case 'Misc':
            return {
                items,
                traveller,
                headerType: 'travellerName'
            };
        case 'BusinessLounge':
        case 'CapsuleHotel':
        case 'PriorityBoarding':
            return {
                items,
                traveller,
                allSegments: isAllSegments,
                headerType: 'travellerName',
                direction: segment
            };
        case 'Baggage':
        case 'Animal':
        case 'Transfer':
            const itemsBySegmentMap = new Map();
            items.forEach(item => {
                var _a;
                const key = item.segment;
                itemsBySegmentMap.set(key, [...((_a = itemsBySegmentMap.get(key)) !== null && _a !== void 0 ? _a : []), item]);
            });
            return [...itemsBySegmentMap.entries()].map(([key, items]) => {
                const isAllSegments = key === 'allSegments';
                const direction = !isAllSegments ? segments.find(segment => segment.id === key) : null;
                return {
                    items,
                    traveller,
                    headerType: 'travellerName',
                    direction: direction,
                    allSegments: isAllSegments
                };
            });
        case 'Sms':
            return {
                items: items.map(item => (Object.assign(Object.assign({}, item), { name: traveller.name })))
            };
        case 'RefundableTicket':
            return {
                items,
                traveller,
                headerType: 'serviceName'
            };
        default:
            return null;
    }
}
